import React, { useState } from 'react';
// import BackToServicesButton from '../components/BackToServicesButton';
import API_BASE_URL from '../api';
import { authFetch } from '../authFetch';
import { useAuth } from '../authContext';
import useSelectedRadio from '../hooks/useSelectedRadio';
import { useTranslation } from 'react-i18next';
import { fmtNumber, useLocale } from '../i18n/format';
import ExportButton from '../components/ExportButton';
import { buildLoyaltyDoc } from "../pdf/builders/loyalty/buildDoc";

export default function LoyaltyServicePage() {
  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  });
  const [result, setResult] = useState('');
  const [period, setPeriod] = useState('');
  const [error, setError] = useState('');
  const { radioId, shortcode, name: stationName } = useSelectedRadio();
  const { isAuth } = useAuth();
  const { t } = useTranslation('common');
  const locale = useLocale();

  const fetchData = async () => {
    if (!isAuth || !radioId || !date) return;
    setResult(t('common.loading'));
    setPeriod('');
    setError('');
    try {
      const API = (API_BASE_URL || '').replace(/\/+$/, '');
      const resp = await authFetch(`${API}/radios/${encodeURIComponent(radioId)}/metrics/loyalty-rate?date1=${date}`);
      const data = await resp.json();
      if (data.error) {
        setResult('');
        setError(data.error);
        return;
      }
      const loyal = data.loyal_scaled || 0;
      const total = data.uniq_all || 0;
      const percent = data.percent || 0;
      setResult(
        t('loyalty.result', {
          loyal: fmtNumber(loyal, locale),
          total: fmtNumber(total, locale),
          percent: fmtNumber(percent, locale)
        })
      );
      setPeriod(t('loyalty.period_note', { start: data.start, end: data.end }));
    } catch {
      setResult('');
      setError(t('common.network_error'));
    }
  };

  if (!radioId) {
    return (
      <div style={widgetStyle}>
        {/* BackToServicesButton removed */}
        <h2 style={{ marginBottom: 8 }}>{t('loyalty.title')}</h2>
        <div style={{ color: '#e54848', fontWeight: 600, fontSize: 18 }}>
          {t('common.no_channel')}
        </div>
      </div>
    );
  }

  return (
    <div style={widgetStyle}>
      {/* BackToServicesButton removed */}

      {/* Описание сервиса */}
      <div
        style={{
          width: "100%",
          padding: "12px 14px",
          borderRadius: 8,
          background: "#f8f8f8",
          color: "#1a1a1a",
          fontSize: 16.5,
          margin: "8px 0 20px 0",
          boxSizing: "border-box",
          whiteSpace: "pre-line",
          lineHeight: 1.65
        }}
      >
        {t('loyalty.description')}
      </div>

      <div style={{fontSize:'1.18em', fontWeight:'bold', marginBottom:10}}>{t('loyalty.title')}</div>
      <div style={{marginBottom:12}}>
        <label style={{fontWeight:'normal'}}>📅 {t('retention.end_date')}</label>
        <input type="date" value={date} onChange={e => setDate(e.target.value)} style={inputStyle} />
        <span style={{fontSize:'0.92em', color:'#999'}}> {t('retention.calc_hint')}</span>
        <button
          type="button"
          onClick={fetchData}
          style={{
            background: '#3867fa',
            color: '#fff',
            border: 'none',
            padding: '8px 16px',
            borderRadius: 5,
            fontWeight: 600,
            cursor: 'pointer',
            marginLeft: 10,
            width: 160
          }}
        >
          {t('common.show')}
        </button>
        <div style={{ display: 'inline-block', marginLeft: 8 }}>
          <ExportButton
            data={{ result, period }}
            onBeforeBuild={async () => {
              // логотип из public
              const url = `${process.env.PUBLIC_URL || ''}/Radiomonitor.NetLogo.png`;
              try {
                const resp = await fetch(url, { cache: 'no-store' });
                const blob = await resp.blob();
                const reader = new FileReader();
                const dataUrl = await new Promise((res, rej) => {
                  reader.onloadend = () => res(reader.result);
                  reader.onerror = rej;
                  reader.readAsDataURL(blob);
                });
                return { logoDataUrl: dataUrl };
              } catch {
                return { logoDataUrl: null };
              }
            }}
            buildDoc={(payload) =>
              buildLoyaltyDoc({
                t, shortcode, stationName,
                serviceName: t('loyalty.title'),
                date,
                // result на странице — HTML-строка; для PDF отдаём plain text
                resultText: String(result || '').replace(/<[^>]+>/g, ''),
                period,
                logoDataUrl: payload?.logoDataUrl || null
              })
            }
            filename={`loyalty_${shortcode}_${date}.pdf`}
            label={t('export_pdf')}
            style={{
              background: (!!error || !result) ? '#9bbdfd' : '#3867fa',
              color: '#fff',
              border: 'none',
              padding: '8px 16px',
              borderRadius: 5,
              fontWeight: 600,
              cursor: 'pointer',
              marginLeft: 10,
              width: 160
            }}
            disabled={!!error || !result}
          />
        </div>
      </div>
      <div style={{fontSize:'1.45em', fontWeight:'bold', color:'#1785db', marginBottom:7}}>
        {error ? <span style={{color:'#e54848'}}>{error}</span> : result ? <span dangerouslySetInnerHTML={{ __html: result }} /> : null}
      </div>
      <div style={{color:'#888', fontSize:'0.96em'}}>{period}</div>
    </div>
  );
}

const widgetStyle = {
  maxWidth: 1100,
  background: '#f9fafc',
  borderRadius: 14,
  padding: '18px 24px',
  border: '1px solid #eef1f4',
  margin: '40px auto'
};

const inputStyle = {
  marginLeft: 8,
  padding: 7,
  borderRadius: 4,
  border: '1px solid #ccc',
  fontSize: 16,
  minWidth: 130
};
